<template>
  <div class="mx-auto w-full max-w-sm">
    <BaseCard class="relative">
      <UserPasswordForm @submit="onSubmit" />
      <template v-if="isSubmitting">
        <BaseInnerLoading />
      </template>
    </BaseCard>
  </div>
</template>

<script setup lang="ts">
import { ApiError } from "@/api"
import type { SubmissionContext } from "vee-validate"
import type {
  UserPasswordFormInput,
  UserPasswordFormOutput,
} from "@/components/UserPasswordForm.vue"

const router = useRouter()
const { setPageTitle } = usePageTitle()
const { currentUser } = useCurrentUser()
const changePasswordText = computed(() =>
  currentUser.value?.hasPassword
    ? "Change Password"
    : "Set Password"
)
watch(
  () => changePasswordText.value,
  (value) => setPageTitle(value),
  { immediate: true }
)
const isSubmitting = ref(false)
const onSubmit = async (
  params: UserPasswordFormOutput,
  context: SubmissionContext<UserPasswordFormInput>
) => {
  isSubmitting.value = true
  try {
    await changePassword(params)
    toast.success("Password updated")
    router.push({ name: "home" })
  } catch (error) {
    if (
      error instanceof ApiError &&
      error.code === "invalid-password"
    ) {
      context.setFieldError("password", error.detail)
      return
    }

    logError(error)
    toast.error("Failed to update password")
  } finally {
    isSubmitting.value = false
  }
}
</script>
